export default __webpack_public_path__ + "static/media/link-icon-alt.cc3b02a7.svg";